import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Compass, ArrowLeft } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme !== 'light';
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="not-found-page">
      <Compass className={cnHelper('h-12 w-12 mb-4', isDark ? 'text-slate-500' : 'text-slate-400')} />
      <p className={cnHelper('text-5xl font-extrabold tracking-tight', isDark ? 'text-slate-100' : 'text-slate-800')}>404</p>
      <h1 className={cnHelper('mt-2 text-lg font-semibold', isDark ? 'text-slate-200' : 'text-slate-700')}>This page doesn’t exist</h1>
      <p className={cnHelper('mt-1 text-sm max-w-md', isDark ? 'text-slate-400' : 'text-slate-500')}>
        We couldn’t find <code className={cnHelper('px-1 py-0.5 rounded', isDark ? 'bg-white/10 text-slate-300' : 'bg-slate-100 text-slate-600')}>{location.pathname}</code>.
        It may have moved or been retired.
      </p>
      <div className="mt-6 flex items-center gap-3">
        <Button
          variant="outline"
          onClick={() => navigate(-1)}
          data-testid="not-found-back-btn"
          className={isDark ? 'border-slate-600 text-slate-200 hover:bg-white/10 hover:text-white' : undefined}
        >
          <ArrowLeft className="h-4 w-4 mr-2" /> Go back
        </Button>
        <Button onClick={() => navigate('/')} data-testid="not-found-home-btn">Go to dashboard</Button>
      </div>
    </div>
  );
}

function cnHelper(...parts) {
  return parts.filter(Boolean).join(' ');
}

